export const USER_LOGGED = 'USER_LOGGED'
export const USER_WALL_ID = 'USER_WALL_ID'
